import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';

class ScheduleConfirmRecursiveDelete extends Component {

    render(){
        const p = this.props;
        const actions = [
            <Button
                key="CancelButton"
                type="CancelButton"
                className="btn-space"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={this.props.close}
            />,
            <Button
                key="ConfirmButton"
                name="buttonJustThis"
                className="pull-right btn-space"
                label="Just this"
                primary={true}
                onTouchTap={this.props.deleteSingleSchedule}
            />,
            <Button
                key="SaveButton"
                name="buttonAllSchedules"
                className="pull-right btn-space"
                label="All recursive"
                primary={true}
                onTouchTap={this.props.deleteAllSchedule}
            />

        ];

        return(
            <div>
                <DialogInput
                    // title="Delete recursive schedule"
                    title={<DialogHeaderWithClose text="Delete recursive schedule" handleClose={() => this.props.close()} />}
                    modal={true}
                    actions = {actions}
                    className="schedule_dialog"
                    open={p.open}
                    autoScrollBodyContent={true}
                    >

                    <div className="row m-2">
                        This schedule was created as a recursive schedule. Do you want to delete just this day or all schedules created with this one?
                    </div>
                </DialogInput>
            </div>
        );
    }
}


export default ScheduleConfirmRecursiveDelete;
